const convertHexToRgba = (hexInput: string, opacity = 1) => {
  // get rid of leading "#"
  const hex = hexInput.slice(1);

  // if input is in a shorthand form (e.g. #FFF), we normalize it to 6 chars format
  const normalizedHex =
    hex.length === 3
      ? hex
          .split('')
          .map((c) => c + c)
          .join('')
      : hex;

  const r = parseInt(normalizedHex.substring(0, 2), 16);
  const g = parseInt(normalizedHex.substring(2, 4), 16);
  const b = parseInt(normalizedHex.substring(4, 6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export default convertHexToRgba;
